// Storefront design tokens, imagery + helpers (scoped to public store only)

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/7a0d6fd8235c5e0bd4e91de17ce9eef108fe5a8cc13a101a6b8f46a82c50fa0b.png";

const CATEGORY_IMAGES = [
  { kw: ["air condition", "ac ", " ac", "hvac", "cooling"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/f942a10b75f2959c79219956422f485b074bfe90f717e87c3e4eacc8df54efb0.png" },
  { kw: ["refriger", "fridge"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/96bfd921c7c79e9b1b36dbd5afc764528d88a500a633aadaa41a27b6e9fc133e.png" },
  { kw: ["washing", "washer", "laundry"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/01729deb6de223f248c45697446b25b924eb75744e04404600d5e7b6e369208f.png" },
  { kw: ["televis", "tv", "led", "lcd", "smart tv"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/7e64eaec80a007a50e7e1577884b7eda2cbab784a0522d3d558da71a282aca7f.png" },
  { kw: ["clean", "sofa", "housekeep"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/3e432d5b66cb9bad820925e8e910e8e7bad67b85fad79ef861de155a6c35df6f.png" },
  { kw: ["plumb", "tap", "sink", "bathroom", "pipe", "water"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/46d83425a0c263ff95d5405ea3f1cce87552bba48d7f16f6a41455b099e9af46.png" },
  { kw: ["electric", "wiring", "switch", "socket", "fan"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/2fbf43269a23bda64cf8e9e208a6f4021ef89b2418c2d0e638373361c3dca9ea.png" },
  { kw: ["pest", "termite", "cockroach", "fumig"], url: "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/95d72340f6ca63913157d84cca9cc3e9b0611577fbede268bf9140cc09ab9a61.png" },
];

const FALLBACK_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/6e0597e9-22df-4e34-b718-793217de5336/images/9f7c473033f8c15fe1672dc73828a6a33e9690e0ecdb2b27b8383b9cc70ea43a.png";

export function categoryImage(name = "") {
  const n = (" " + name + " ").toLowerCase();
  const hit = CATEGORY_IMAGES.find((c) => c.kw.some((k) => n.includes(k)));
  return hit ? hit.url : FALLBACK_IMAGE;
}

// Derive a believable strikethrough MRP from the live price (presentational only)
export function mrp(amount) {
  return Math.round((amount * 1.25) / 10) * 10;
}
export function discountPct(amount) {
  const m = mrp(amount);
  return m > amount ? Math.round(((m - amount) / m) * 100) : 0;
}

// Editable marketing testimonials (not live feedback data)
export const TRUST_STATS = { customers: "20,000+", rating: "4.1", pros: "1,200+", cities: "3" };

export const PARTNER_BENEFITS = [
  { icon: "Briefcase", title: "Steady verified jobs", text: "Get a regular flow of genuine, paying customers in your service areas." },
  { icon: "CurrencyInr", title: "On-time payouts", text: "Transparent earnings with reliable, timely settlements to your bank." },
  { icon: "ShieldCheck", title: "Trusted brand", text: "Work under the Fixigo name customers already know and trust." },
  { icon: "Headset", title: "Dedicated support", text: "A partner success team to help you grow and resolve issues fast." },
];

export const PARTNER_TERMS = `FIXIGO PARTNER TERMS & CONDITIONS

1. Engagement
By registering as a Fixigo partner, you agree to provide home services to customers assigned through the Fixigo platform as an independent service professional. You are not an employee of Fixigo.

2. Service Standards
You agree to deliver services professionally, punctually and safely, in line with Fixigo's quality guidelines and applicable laws. You will carry valid identification and wear appropriate safety gear where required.

3. 90-Day Service Warranty
You provide a NINETY (90) DAY WORKMANSHIP WARRANTY on every completed job. If the same issue recurs within 90 days of service completion due to the work performed, you will re-attend and rectify it at no additional labour cost to the customer. This warranty excludes new/unrelated faults, customer misuse, third-party tampering, and parts not supplied or installed by you.

4. Pricing & Payments
Service prices are as listed on the Fixigo platform. Fixigo operates on a pay-after-service model. Payouts to your registered bank account are made as per the agreed settlement cycle, net of applicable platform fees and taxes.

5. Documents & Verification
You confirm that all documents submitted (including Aadhaar, PAN, and any GST/MSME records) are genuine and belong to you or your registered business. Fixigo may verify these and suspend accounts found to be fraudulent.

6. Conduct
Any misbehaviour, fraud, repeated poor ratings, or breach of these terms may lead to suspension or termination of your partner account.

7. Data
You consent to Fixigo storing and processing your details to operate the partner programme, in line with the Fixigo Privacy Policy.

8. Bank & Tax
You are responsible for the accuracy of your bank details and for your own tax compliance on the income earned.

9. Changes
Fixigo may update these terms from time to time. Continued use of the partner platform constitutes acceptance.

10. Governing Law
These terms are governed by the laws of India, with jurisdiction in Bengaluru, Karnataka.

This is a general template and does not constitute legal advice. Please review with a qualified professional.`;

export const REVIEWS = [
  { name: "Ananya Sharma", city: "Bengaluru", stars: 5, text: "Booked a Split AC service in the morning and the technician arrived within 2 hours. Polite, neat work and transparent pricing. Highly recommend!" },
  { name: "Rohit Verma", city: "Pune", stars: 4, text: "Got my washing machine drain pump fixed. The partner explained the issue clearly and charged exactly what was quoted on the website." },
  { name: "Sneha Patil", city: "Mumbai", stars: 5, text: "The deep cleaning team did an amazing job on our 2BHK before Diwali. Spotless kitchen and bathrooms. Will definitely book again." },
  { name: "Karthik Reddy", city: "Bengaluru", stars: 4, text: "Reliable refrigerator repair. Loved that I could track the job status and pay only after the service was completed." },
  { name: "Aditi Joshi", city: "Pune", stars: 5, text: "Pest control service was thorough and odour-free. The professional wore proper safety gear. Felt very safe and hygienic." },
  { name: "Rahul Mehta", city: "Mumbai", stars: 4, text: "Quick electrician visit for switchboard repair. Booking was simple and the upfront pricing made it completely stress-free." },
];
